import { useEffect, useState } from "react";

export function usePreview() {
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    const checkHash = () => {
      const isPreviewHash = window.location.hash === "#preview";
      setIsPreview(isPreviewHash);
    };

    checkHash();
    window.addEventListener("hashchange", checkHash);

    return () => {
      window.removeEventListener("hashchange", checkHash);
    };
  }, []);

  return isPreview;
}
